module.exports = __webpack_public_path__ + "static/img/rotationPlot_4.279be28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rotationPlot/rotationPlot_4.jpg
// module id = 1Xx3
// module chunks = 0